export type OgType = 'product' | 'article' | 'website';

export const getOgType = (pathname: string): OgType => {
    if (pathname === '/product/[id]') {
        return 'product';
    }

    if (pathname === '/news/[slug]') {
        return 'article';
    }

    return 'website';
};
